import { useEffect } from 'react';
import { useTaxPercentageLazyQuery } from 'src/generated/graphql';

interface useFetchTaxPercentageArgs {
  countryCode: string;
  vatNumber?: string;
}
function useFetchTaxPercentage({ countryCode, vatNumber }: useFetchTaxPercentageArgs): number {
  const [getTaxPercentage, { data }] = useTaxPercentageLazyQuery({ fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (countryCode) {
      getTaxPercentage({ variables: { countryCode, vatNumber } });
    }
  }, [countryCode, getTaxPercentage, vatNumber]);

  return data?.tax?.percentage || 0;
}

export default useFetchTaxPercentage;
